module.exports = __webpack_public_path__ + "img/my_amount_back.ccafa3fa.png";